import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        defaultTheme: 'light',
        dark: false,
        themes: {
            light: {
                primary: '#47bd82',
                darkprimary: '#508B46',
                darkprimary_2 : '#4CAF50',
                secondary: '#fafafa',
                success: '#2ac770',
                warning: '#fbae43',
                darkwarning : '#D47301',
                accent: '#8c9eff',
                info: '#029ce5',
                error: '#eb5455',
                light: '#ffffff',
                gray: '#777777',
                // darkgray: '#A9A9A9',

                bgPrimary: '#E8F5E9',
                bgSecondary: '#fcfcfc',
                bgSuccess: '#E8F5E9',
                bgWarning: '#FFF8E1',
                bgAccent: '#8c9eff',
                bgInfo: '#E3F2FD',
                bgError: '#ffe0dc',
                bgDarkgray: '#A9A9A9',
               
                fontPrimary: '#47bd82',
                fontSecondary: '#fafafa',
                fontSuccess: '#3A7847',
                fontWarning: '#D0772C',
                fontAccent: '#8c9eff',
                fontInfo: '#0691E1',
                fontError: '#D23438',
                fontDarkgray: '#9E9E9E',

                fontBgPrimary: '#E8F5E9',
                fontBgSecondary: '#F5F5F5',
                fontBgSuccess: '#D2F5E0',
                fontBgWarning: '#FCECBC',
                fontBgAccent: '#E8F5E9',
                fontBgInfo: '#E3F0FA',
                fontBgError: '#FAE3E6',
                fontBgDarkgray: '#E4E6E8',

                bgTooltip: '#66bb6a',
                darkgray: '#616161',
                bedrock: '#015850',
                footer: '#508B46'
            },
            dark: {
                primary: '#47bd82',
                darkprimary: '#508B46',
                secondary: '#fafafa',
                success: '#2ac770',
                warning: '#fbae43',
                accent: '#8c9eff',
                info: '#029ce5',
                error: '#eb5455',
                darkgray: '#616161',
                bedrock: '#015850',
                footer: '#508B46'
            },
        },
    },
});
